export class BydAlertDataInterface {
  /**
   *
   */
  text: string;

  /**
   *
   */
  type: 'error' | 'success';

  /**
   * Ma caracter.
   */
  maxCaracter?: number;

  /**
   * Second action icon.
   */
  secondActionIcon?: string;

  /**
   * Disable close.
   */
  disableClose?: boolean;
}
